<template>
  <div class="statistics">
    <div id="map"></div>
    <div class="search">
      <div class="search_box">
        <div  class="search_options_box">
          <span style="width: 100px;">{{search[0].title}}</span>
          <el-select class="select" v-model="selectProjectValue" placeholder="请选择项目" @change="getSelectTeam(selectProjectValue )">
            <el-option v-for="item in search[0].options" :label="item.label" :value="item.value" :key="item.value"></el-option>
          </el-select>
        </div>
        <div  class="search_options_box">
          <span style="width: 100px;">{{search[1].title}}</span>
          <el-select class="select" v-model="selectTeamValue" placeholder="请选择群组" @change="getSelectWork(selectTeamValue )">
            <el-option v-for="item in search[1].options" :label="item.label" :value="item.value" :key="item.value"></el-option>
          </el-select>
        </div>
        <div  class="search_options_box">
          <span style="width: 100px;">{{search[2].title}}</span>
          <el-select class="select" v-model="selectWorkValue" placeholder="请选择小组" >
            <el-option v-for="item in search[2].options" :label="item.label" :value="item.value" :key="item.value"></el-option>
          </el-select>
        </div>
        <div class="search_btn_box">
          <button :class='["search_btn","green","icon_btn","clearborder"]'><span class="el-icon-search"></span>搜索</button>
        </div>
      </div>
    </div>


    <div :class='["information_box","light_border","weather_box"]'
         :style="[{width:'520px'},{height:'35%'},{left:'20px'},{top:'140px'}]">
      <div class="border_top_left"></div>
      <div class="border_top_right"></div>
      <div class="border_bottom_left"></div>
      <div class="border_bottom_right"></div>
      <div class="h_light_right" :style="{top:'95px'}"></div>
      <div class="information_content">
        <div class="weather">
          <h1>未来一周天气预报</h1>
          <div>
            <div>
              <img v-if="weather_data[0].wea_img==='xue'" src="/static/img/weather/weather1.png" alt="雪">
              <img v-else-if="weather_data[0].wea_img==='lei'" src="/static/img/weather/weather2.png" alt="雷">
              <img v-else-if="weather_data[0].wea_img==='shachen'" src="/static/img/weather/weather3.png" alt="沙尘">
              <img v-else-if="weather_data[0].wea_img==='wu'" src="/static/img/weather/weather4.png" alt="雾">
              <img v-else-if="weather_data[0].wea_img==='bingbao'" src="/static/img/weather/weather5.png" alt="冰雹">
              <img v-else-if="weather_data[0].wea_img==='yun'" src="/static/img/weather/weather6.png" alt="多云">
              <img v-else-if="weather_data[0].wea_img==='yu'" src="/static/img/weather/weather7.png" alt="雨">
              <img v-else-if="weather_data[0].wea_img==='yin'" src="/static/img/weather/weather8.png" alt="阴">
              <img v-else-if="weather_data[0].wea_img==='qing'" src="/static/img/weather/weather9.png" alt="晴">
              <div>
                <h2>
                  {{city}}
                  <span v-if="pollutant_data.air<=100" :style="{background:'#2ad789'}">{{pollutant_data.air}}{{pollutant_data.air_level}}</span>
                  <span v-else-if="pollutant_data.air<=200 && pollutant_data.air>100" :style="{background:'#f4b13d'}">{{pollutant_data.air}}{{pollutant_data.air_level}}</span>
                  <span v-else-if="pollutant_data.air<=300 && pollutant_data.air>200" :style="{background:'#f46d3d'}">{{pollutant_data.air}}{{pollutant_data.air_level}}</span>
                  <span v-else-if="pollutant_data.air>300" :style="{background:'#e82414'}">{{pollutant_data.air}}{{pollutant_data.air_level}}</span>
                </h2>
                <p>{{weather_data[0].date}}</p>
                <p>{{weather_data[0].week}}</p>
              </div>
              <div>
                <p>{{tem}}</p>
                <p>{{weather_data[0].wea}}</p>

              </div>
            </div>
            <ul>
              <li v-for="(item,index) in weather_data" v-if="index>0">
                <p>{{item.day}}</p>
                <p>{{item.tem1}}~{{item.tem2}}</p>
                <img v-if="item.wea_img==='xue'" src="/static/img/weather/weather1.png" alt="雪">
                <img v-else-if="item.wea_img==='lei'" src="/static/img/weather/weather2.png" alt="雷">
                <img v-else-if="item.wea_img==='shachen'" src="/static/img/weather/weather3.png" alt="沙尘">
                <img v-else-if="item.wea_img==='wu'" src="/static/img/weather/weather4.png" alt="雾">
                <img v-else-if="item.wea_img==='bingbao'" src="/static/img/weather/weather5.png" alt="冰雹">
                <img v-else-if="item.wea_img==='yun'" src="/static/img/weather/weather6.png" alt="多云">
                <img v-else-if="item.wea_img==='yu'" src="/static/img/weather/weather7.png" alt="雨">
                <img v-else-if="item.wea_img==='yin'" src="/static/img/weather/weather8.png" alt="阴">
                <img v-else-if="item.wea_img==='qing'" src="/static/img/weather/weather9.png" alt="晴">
                <p>{{item.wea}}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div :class='["information_box","light_border","weather_box"]'
         :style="[{width:'520px'},{height:'calc(65% - 180px)'},{left:'20px'},{top:'calc(35% + 160px)'}]">
      <div class="border_top_left"></div>
      <div class="border_top_right"></div>
      <div class="border_bottom_left"></div>
      <div class="border_bottom_right"></div>
      <div class="h_light_right" :style="{top:'95px'}"></div>
      <div class="information_content">
        <div class="pollutant">
          <h1>污染源分析</h1>
          <p>
            <span :style="{'text-align':'left'}">污染物项目</span>
            <span :style="[{'text-align':'right'},{padding:'0 15px 0 0'}]">浓度限值</span></p>
          <ul>
            <li>
              <span>SO₂</span>
              <div>
                <div :style="{'background':'#00f0ff'}"></div>
                <div :style="{'border-color':'#00f0ff'}">
                  <span :style="[{'background':'#00f0ff'},{width:0}]">
                    <span :style="{'color':'#00f0ff'}">0</span>
                  </span>
                </div>
              </div>
              <span>150μg/m³</span>
            </li>
            <li>
              <span>NO₂</span>
              <div>
                <div :style="{'background':'#0096f3'}"></div>
                <div :style="{'border-color':'#0096f3'}">
                  <span :style="[{'background':'#0096f3'},{width:0}]">
                    <span :style="{'color':'#0096f3'}">0</span>
                  </span>
                </div>
              </div>
              <span>80μg/m³</span>
            </li>
            <li>
              <span>CO</span>
              <div>
                <div :style="{'background':'#00c0e9'}"></div>
                <div :style="{'border-color':'#00c0e9'}">
                  <span :style="[{'background':'#00c0e9'},{width:0}]">
                    <span :style="{'color':'#00c0e9'}">0</span>
                  </span>
                </div>
              </div>
              <span>4mg/m³</span>
            </li>
            <li>
              <span>O₃</span>
              <div>
                <div :style="{'background':'#00e9db'}"></div>
                <div :style="{'border-color':'#00e9db'}">
                  <span :style="[{'background':'#00e9db'},{width:0}]">
                    <span :style="{'color':'#00e9db'}">0</span>
                  </span>
                </div>
              </div>
              <span>160μg/m³</span>
            </li>
            <li>
              <span>PM10</span>
              <div>
                <div :style="{'background':'#34da62'}"></div>
                <div :style="{'border-color':'#34da62'}">
                  <span :style="[{'background':'#34da62'},{width:0}]">
                    <span :style="{'color':'#34da62'}">0</span>
                  </span>
                </div>
              </div>
              <span>150μg/m³</span>
            </li>
<!--            <li>-->
<!--              <span>PM2.5</span>-->
<!--              <div>-->
<!--                <div :style="{'background':'#d0a00e'}"></div>-->
<!--                <div :style="{'border-color':'#d0a00e'}">-->
<!--                  <span :style="[{'background':'#d0a00e'},{width:0}]">-->
<!--                    <span :style="{'color':'#d0a00e'}">0</span>-->
<!--                  </span>-->
<!--                </div>-->
<!--              </div>-->
<!--              <span>75μg/m³</span>-->
<!--            </li>-->
            <li>
              <span>TSP</span>
              <div>
                <div :style="{'background':'#d0570e'}"></div>
                <div :style="{'border-color':'#d0570e'}">
                  <span :style="[{'background':'#d0570e'},{width:0}]">
                    <span :style="{'color':'#d0570e'}">0</span>
                  </span>
                </div>
              </div>
              <span>300μg/m³</span>
            </li>
            <li>
              <span>NOx</span>
              <div>
                <div :style="{'background':'#eb3600'}"></div>
                <div :style="{'border-color':'#eb3600'}">
                  <span :style="[{'background':'#eb3600'},{width:0}]">
                    <span :style="{'color':'#eb3600'}">0</span>
                  </span>
                </div>
              </div>
              <span>100μg/m³</span>
            </li>
<!--            <li>-->
<!--              <span>噪声</span>-->
<!--              <div>-->
<!--                <div :style="{'background':'#eb2100'}"></div>-->
<!--                <div :style="{'border-color':'#eb2100'}">-->
<!--                  <span :style="[{'background':'#eb2100'},{width:0}]">-->
<!--                    <span :style="{'color':'#eb2100'}">0</span>-->
<!--                  </span>-->
<!--                </div>-->
<!--              </div>-->
<!--              <span>60dB</span>-->
<!--            </li>-->
          </ul>
        </div>
      </div>
    </div>

    <div :class='["information_box","light_border","weather_box"]'
         :style="[{width:'calc(100% - 580px)'},{height:'calc(100% - 560px)'},{left:'560px'},{top:'540px'}]">
      <div class="border_top_left"></div>
      <div class="border_top_right"></div>
      <div class="border_bottom_left"></div>
      <div class="border_bottom_right"></div>
      <div class="h_light_right" :style="{top:'95px'}"></div>
      <div class="information_content">
        <div class="monitoringPoint">
          <h1>各监测点实时数据</h1>
          <div>
            <table>
              <thead>
              <tr>
                <th>灯杆编号</th>
                <th>AQI</th>
                <th>空气质量状况</th>
                <th>温度（℃）</th>
                <th>湿度（RH）</th>
                <th>噪声（dB）</th>
                <th>PM2.5（μg/m³）</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in table_data">
                <td>{{item.lamppost}}</td>
                <td>{{item.haze}}</td>
                <td>
                  <span v-if="item.haze<=100" :style="{background:'#2ad789'}">良</span>
                  <span v-else-if="item.haze>100 && item.haze<=200" :style="{background:'#f4b13d'}">轻度</span>
                  <span v-else-if="item.haze>200 && item.haze<=300" :style="{background:'#f46d3d'}">中度</span>
                  <span v-else-if="item.haze>300" :style="{background:'#e82414'}">严重</span>
                </td>
                <td>{{item.temperature}}</td>
                <td>{{item.humidity}}</td>
                <td>{{item.noise}}</td>
                <td>{{item.haze}}</td>
              </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>

    <div id="details" :class='["information_box","light_border","weather_box"]'
         :style="[{width:'500px'},{height:'380px'},{right:'18px'},{top:'140px'}]">
      <div class="border_top_left"></div>
      <div class="border_top_right"></div>
      <div class="border_bottom_left"></div>
      <div class="border_bottom_right"></div>
      <div class="h_light_right" :style="{top:'95px'}"></div>
      <div class="information_content">
        <div class="details">
          <h1>
            <span id="site">各监测点实时数据</span>
            <span id="date"></span>
            <button @click="close()">X</button>
          </h1>
          <div>
            <span id="air"></span>
            <div>
              <p>空气质量</p>
              <p id="air_level">轻度污染</p>
            </div>
          </div>
          <p>数值越大，污染越严重</p>
          <div>
            <div>
              <span id="progress"></span>
            </div>
          </div>
          <h3>健康影响：<span id="influence">易感人群症状有轻度加剧，健康人群出现刺激症状</span></h3>
          <h3>建议措施：<span id="measure">建议儿童、老人以及心脏病、呼吸系统疾病患者减少户外锻炼</span></h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "statistics",
    computed: {
      mapstyle() {
        return this.$store.state.mapstyle
      }
    },
    data() {
      return {
        //初始化分页
        totalPage: 1, // 统共页数，默认为1
        currentPage: 1, //当前页数 ，默认为1
        pageSize: 10, // 每页显示数量
        //需要获取的数据
        city: '安平',
        search: [
          {
            title: '选择项目',
            options: [],
          }, {
            title: '选择群组',
            options: [],
          }, {
            title: '选择小组',
            options: [],
          },
        ],
        projectList:[],
        teamList:[],
        workList:[],
        selectProjectValue:'',
        selectTeamValue:'',
        selectWorkValue:'',
        point: [],

        weather_data: [
          {air: "", air_level: "", date: "", week: "", tem: "", wea: "", wea_img: "",hours:[{ day:"",wea:"",tem:"",win:"",win_speed:""}]},
          {day: "", tem1: "", tem2: "", wea_img: "", wea: ""},
          {day: "", tem1: "", tem2: "", wea_img: "", wea: ""},
          {day: "", tem1: "", tem2: "", wea_img: "", wea: ""},
          {day: "", tem1: "", tem2: "", wea_img: "", wea: ""},
          {day: "", tem1: "", tem2: "", wea_img: "", wea: ""},
          {day: "", tem1: "", tem2: "", wea_img: "", wea: ""},
        ],
        pollutantNone_data:{
          co: 3.2,
          tsp: 120,
          nox: 10,
          noise: 40
        },

        pollutant_data: {
          // so2: 100,
          // no2: 70,
          // o3: 50,
          // pm10: 10,
          // pm25: 10,

        },
        table_data: [],
        tem:'',


      }
    },
    created() {
      this.InitLeftMenu();
      this.city = "安平";
      this.$axios.get('/api/v1/common/weather?city=安平')
       .then(res => {                   //请求成功后的处理函数
        this.weather_data = res.data.data;
         this.parseDate();
      }).catch(err => {                 //请求失败后的处理函数
        throw  err;
      });
      // this.$axios.post('/api/v1/sensor/record/list', {})
      //   .then(res => {                   //请求成功后的处理函数
      //     this.table_data = res.data
      //   }).catch(err => {                 //请求失败后的处理函数
      //   throw  err;
      // })




    },

    mounted() {
      this.getpmlist();
      this.drawMap();
      $("#details").hide();
      this.newData();
      this.getProjectList();

    },
    methods: {

      getpmlist:function(){
        this.$axios.get('/api/v1/common/pm25?city=安平')
          .then(res => {                   //请求成功后的处理函数
            this.pollutant_data = res.data;
          }).catch(err => {                 //请求失败后的处理函数
          throw  err;
        });
      },



      parseDate: function () {
          var date = new Date();
          var y = date.getFullYear();
          var m = date.getMonth() + 1;
          m = m < 10 ? ('0' + m) : m;
          var d = date.getDate();
          d = d < 10 ? ('0' + d) : d;
          var hs = date.getHours();
          var minute = date.getMinutes();
          minute = minute < 10 ? ('0' + minute) : minute;
          var second= date.getSeconds();
          second = minute < 10 ? ('0' + second) : second;
          var h = parseInt(hs);
          if(8<=h&&h<11){
            this.tem = this.weather_data[0].hours[0].tem;
          }else if (11<=h&&h<14){
            this.tem = this.weather_data[0].hours[1].tem;
          }
          else if (14<=h&&h<17){
            this.tem = this.weather_data[0].hours[2].tem;
          }
          else if (17<=h&&h<20){
            this.tem = this.weather_data[0].hours[3].tem;
          }
          else if (20<=h&&h<23){
            this.tem = this.weather_data[0].hours[4].tem;
          }
          else if (0<=h&&h<2){
            this.tem = this.weather_data[0].hours[5].tem;
          }
          else if (2<=h&&h<5){
            this.tem = this.weather_data[0].hours[6].tem;
          }
          else if (5<=h&&h<8){
            this.tem = this.weather_data[0].hours[7].tem;
          }
      },


      //获取小组列表
      getSelectWork:function(id){
        fetch("/api/v1/controller/list", {
          method: 'post',
          body: JSON.stringify({
            "groups_id":id,
            "page_size":10,
            "page_start":0,
          })
        })
          .then(result => {
            return result.json();//解析流
          })
          //.then(data => console.log(data))
          .then(data => {
            if (data.code == "200") {
              this.message = "小组数据获取成功";
              this.search[2].options=[];
              this.workList = data.data;
              let options = this.search[2].options;
              for (let i=0;i<this.workList.length;i++){
                let projectObj = {};
                projectObj.label = this.workList[i].name;
                projectObj.value = this.workList[i].id;
                options.push(projectObj);
              };
            } else {
              this.message = "数据更新异常，请重试";
            }
          })
          .catch((error) => {
            this.message = "网络异常，请重试";
            this.msg_show = !this.msg_show;
          });
      },



      //获取群组列表
      getSelectTeam:function(id){
        fetch("/api/v1/groups/list", {
          method: 'post',
          body: JSON.stringify({
            "project_id":id,
            "page_size":10,
            "page_start":0,
          })
        })
          .then(result => {
            return result.json();//解析流
          })
          //.then(data => console.log(data))
          .then(data => {
            if (data.code == "200") {
              this.message = "群组数据获取成功";
              this.search[1].options=[];
              this.search[2].options=[];
              this.teamList = data.data;
              let options = this.search[1].options;
              for (let i=0;i<this.teamList.length;i++){
                let projectObj = {};
                projectObj.label = this.teamList[i].name;
                projectObj.value = this.teamList[i].id;
                options.push(projectObj);
              };
            } else {
              this.message = "数据更新异常，请重试";
            }
          })
          .catch((error) => {
            this.message = "网络异常，请重试";
            this.msg_show = !this.msg_show;
          });
      },


      //获取项目列表
      getProjectList:function(){
        fetch("/api/v1/project/list", {
          method: 'post',
          body: JSON.stringify({

          })
        })
          .then(result => {
            return result.json();//解析流
          })
          //.then(data => console.log(data))
          .then(data => {
            if (data.code == "200") {
              this.message = "项目数据获取成功";
              this.projectList = data.data;
              let options = this.search[0].options;
              for (let i=0;i<this.projectList.length;i++){
                let projectObj = {};
                projectObj.label = this.projectList[i].name;
                projectObj.value = this.projectList[i].id;
                options.push(projectObj);
              };
            } else {
              this.message = "数据更新异常，请重试";
            }
          })
          .catch((error) => {
            this.message = "网络异常，请重试";
            this.msg_show = !this.msg_show;
          });
      },


      //实时数据
      newData:function(){
        fetch("/api/v1/sensor/list", {
          method: 'post',
          body: JSON.stringify({
            // project_id: this.project_id,
            // groups_id: this.groups_id,
            // controller_id:this.controller_id,
          })
        })
          .then(result => {
            return result.json();//解析流
          })
          // .then(data => console.log(data))
          .then(data => {
            if (data.code == "200") {
              this.message = "实时数据更新成功";
              this.refresh = true;
              this.msg_show = !this.msg_show;
              this.table_data = data.data;
              let options = this.point;
              for (let i=0;i<this.table_data.length;i++){
                let projectObj = {};
                projectObj.id = this.table_data[i].id;
                projectObj.lng = this.table_data[i].lng;
                projectObj.lat = this.table_data[i].lat;
                projectObj.number = this.table_data[i].haze;
                projectObj.site = this.table_data[i].site;
                options.push(projectObj);
              };
              this.drawMap();
              console.log(table_data);
            } else {
              this.message = "数据更新异常，请重试";
              this.msg_show = !this.msg_show;
            }
          })
          .catch((error) => {
            this.message = "网络异常，请重试";
            this.msg_show = !this.msg_show;
          });
      },
      //地图初始化
      InitLeftMenu: function () {
        this.$emit('getMessage', '1', '0');
      },
      drawMap() {
        let map = new BMap.Map('map');
        let point = new BMap.Point(115.534317,38.22763);// 创建点坐标
        map.centerAndZoom(point, 13);// 初始化地图，设置中心点坐标和地图级别
        map.enableScrollWheelZoom();//启用滚轮放大缩小，默认禁用。
        let points = this.point;//标记点数据
        let styleJson = this.mapstyle;
        //map.setMapStyleV2({styleJson: styleJson});//引入地图样式
        function addMarker(points) {
          //循环建立标注点
          for (var i = 0, pointsLen = points.length; i < pointsLen; i++) {
            var point = new BMap.Point(points[i].lng, points[i].lat); //将标注点转化成地图上的点
            var animation = false; // 动画状态
            //添加监听事件
            map.enableScrollWheelZoom();
            (function () {
              var number = points[i].number;
              let site = points[i].site;
              var myicon = new BMap.Icon("/static/img/icon/map_maker.png", new BMap.Size(20, 20), {
                // 图标中央下端的尖角位置。
                anchor: new BMap.Size(20, 20),
              });
              var marker = new BMap.Marker(point, {icon: myicon}, point[i]);
              var label = new BMap.Label(points[i].number, {
                offset: new BMap.Size(-31, -61),
              });
              if (number > 0 && number <= 100) {
                label.setStyle({
                  width: '81px',
                  height: '61px',
                  'text-align': 'center',
                  'line-height': '50px',
                  background: 'url("/static/img/icon/map_maker_label1.png") no-repeat center center',
                  border: 'none',
                  color: "#fff",
                  fontSize: "20px"//只要对label样式进行设置就可达到在标注图标上显示数字的效果
                });
                marker.setLabel(label);//显示标注点的内容
                marker.setTop('true');
                map.addOverlay(marker);
                label.customData = {'title': '222'};
                if (animation) {
                  marker.setAnimation(BMAP_ANIMATION_BOUNCE);
                }
              } else if (number > 100 && number <= 200) {
                label.setStyle({
                  width: '81px',
                  height: '61px',
                  'text-align': 'center',
                  'line-height': '50px',
                  background: 'url("/static/img/icon/map_maker_label2.png") no-repeat center center',
                  border: 'none',
                  color: "#fff",
                  fontSize: "20px"//只要对label样式进行设置就可达到在标注图标上显示数字的效果
                });
                marker.setLabel(label);//显示标注点的内容
                marker.setTop('true');
                map.addOverlay(marker);
                if (animation) {
                  marker.setAnimation(BMAP_ANIMATION_BOUNCE);
                }
              } else if (number > 200 && number <= 300) {
                label.setStyle({
                  width: '81px',
                  height: '61px',
                  'text-align': 'center',
                  'line-height': '50px',
                  background: 'url("/static/img/icon/map_maker_label3.png") no-repeat center center',
                  border: 'none',
                  color: "#fff",
                  fontSize: "20px"//只要对label样式进行设置就可达到在标注图标上显示数字的效果
                });
                marker.setLabel(label);//显示标注点的内容
                marker.setTop('true');
                map.addOverlay(marker);
                if (animation) {
                  marker.setAnimation(BMAP_ANIMATION_BOUNCE);
                }
              } else {
                label.setStyle({
                  width: '81px',
                  height: '61px',
                  'text-align': 'center',
                  'line-height': '50px',
                  background: 'url("/static/img/icon/map_maker_label4.png") no-repeat center center',
                  border: 'none',
                  color: "#fff",
                  fontSize: "20px"//只要对label样式进行设置就可达到在标注图标上显示数字的效果
                });
                marker.setLabel(label);//显示标注点的内容
                marker.setTop('true');
                map.addOverlay(marker);
                if (animation) {
                  marker.setAnimation(BMAP_ANIMATION_BOUNCE);
                }
              }
              label.addEventListener("click", function (e) {
                var myDate = new Date();
                var mytime = myDate.toLocaleString(); //获取当前时间
                $("#details").fadeIn(200);
                $("#site").text(site + "AQI指数");
                $("#date").text(mytime);
                $("#air").text(number);
                if (number <= 100) {
                  $("#air").css('color', '#2ad789');
                  $("#air_level").html("良");
                  $("#air_level").css('color', '#2ad789');
                  $("#influence").text("可以正常进行室外活动，呼吸清新空气。");
                  $("#progress").css('left', number / 500 * 100 + '%');
                  $("#measure").text("空气质量令人满意，基本无空气污染,各类人群可正常活动。")
                } else if (number <= 200 && number > 100) {
                  $("#air").css('color', '#f4b13d');
                  $("#air_level").html("轻度");
                  $("#air_level").css('color', '#f4b13d');
                  $("#influence").text("易感人群症状有轻度加剧，健康人群出现刺激症状。");
                  $("#progress").css('left', number / 500 * 100 + '%');
                  $("#measure").text("建议儿童、老年人、呼吸系统疾病患者应减少户外锻炼。")
                } else if (number <= 300 && number > 200) {
                  $("#air").css('color', '#f46d3d');
                  $("#air_level").html("中度");
                  $("#air_level").css('color', '#f46d3d');
                  $("#influence").text("加剧易感人群症状，可能对健康人群心脏、呼吸系统有影响。");
                  $("#progress").css('left', number / 500 * 100 + '%');
                  $("#measure").text("疾病患者避免长时间的户外锻练，一般人群减少户外运动。")
                } else if (number > 300 && number < 500) {
                  $("#air").css('color', '#f46d3d');
                  $("#air_level").html("严重");
                  $("#air_level").css('color', '#f46d3d');
                  $("#influence").text("健康人群运动耐受力降低，有明显强烈症状，提前出现某些疾病。");
                  $("#progress").css('left', number / 500 * 100 + '%');
                  $("#measure").text("儿童、老年人和病人应当留在室内，一般人群应避免外出。")
                } else if (number >= 500) {
                  $("#air").css('color', '#f46d3d');
                  $("#air_level").html("严重");
                  $("#air_level").css('color', '#f46d3d');
                  $("#influence").text("健康人群运动耐受力降低，有明显强烈症状，提前出现某些疾病。");
                  $("#progress").css('left', '100%');
                  $("#measure").text("儿童、老年人和病人应当留在室内，一般人群应避免外出。")
                }
              });
            })();

          }
        }

        addMarker(points);
      },
      close() {
        $("#details").fadeOut(200);
      },
    }
  }
</script>

<style scoped>
  .statistics {
    width: 100%;
    height: 100%;
    background: #FFFFFF;
    position: relative;
    overflow-y: auto;
    color: transparent;
  }

  #map {
    width: 100%;
    height: 100%;
  }

  .infoBoxContent {
    margin: 20px;
    position: absolute;
    right: 0;
    top: 50%;
  }

  .infoBoxContent button {
    background-color: #008CBA;
    border: none;
    color: white;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    border-radius: 16px;
    width: 120px;
  }

  .infoBoxContent h3 {
    color: white;
  }

  .infoBoxContent p {
    color: white;
  }

  .infoBoxContent:before {
    content: '';
    width: 0;
    height: 0;
    border: 20px solid transparent;
    border-top-color: #333333;
    position: absolute;
    left: 50%;
    top: 100%;
    margin-left: -20px;
  }


  .search {
    width: 100%;
    height: 140px;
    padding: 20px;
    box-sizing: border-box;
    position: absolute;
    left: 0;
    top: 0;
  }

  .search_box {
    width: 100%;
    height: 100%;
    margin-right: 10px;
    background: #16518d;
    border-radius: 6px;
    float: left;
    display: flex;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
  }

  .search_options_box {
    width: calc(20% - 20px);
    padding: 0 10px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .search_options_box > span {
    width: 64px;
    margin-right: 8px;
    text-align: right;
    color: #FFFFFF;
  }

  .search_options_box > select {
    width: calc(100% - 72px);
    height: 36px;
    border-radius: 6px;
    background: transparent;
    border: 1px solid #a2b9d1;
    color: #a2b9d1;
    appearance: none;
    padding-left: 10px;
    font-size: 16px;
    outline: none;
    cursor: pointer;
  }

  .search_options_box option {
    color: #000000;
  }

  .search_options_box > img {
    position: absolute;
    top: 48px;
    right: 20px;
    cursor: pointer;
  }

  .search_btn_box {
    width: 80px;
    padding: 10px;
  }

  .clearborder {
    outline: none;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .search_btn {
    width: 100%;
    height: 32px;
    border-radius: 6px;
    line-height: 32px;
  }

  .icon_btn span {
    margin-right: 8px;
  }

  .green {
    background: #21b868;
    color: #FFFFFF;
  }

  .green:active {
    background: #15a95a;
  }

  .information_box {
    margin: 0;
    position: absolute;
    top: 0;
  }

  .weather {
    width: 100%;
    height: 100%;
    padding: 20px;
    min-height: 330px;
    box-sizing: border-box;
  }

  .weather > h1:nth-child(1) {
    font-size: 20px;
    color: #00f0ff;
    height: 20px;
    line-height: 20px;
    margin-bottom: 0;
  }

  .weather > div {
    height: calc(100% - 20px);
    width: 100%;
  }

  .weather > div > div:nth-child(1) {
    width: 100%;
    padding-top: 20px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    margin-bottom: 20px;
  }

  .weather > div > div:nth-child(1) > img {
    margin: 10px;
    max-width: 54px;
  }

  .weather > div > div:nth-child(1) > div:nth-child(2) {
    width: auto;
    height: 100%;
    margin-left: 10px;
  }

  .weather > div > div:nth-child(1) > div:nth-child(2) > h2 {
    height: 26px;
    line-height: 26px;
    font-size: 24px;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    margin-bottom: 15px;
  }

  .weather > div > div:nth-child(1) > div:nth-child(2) > h2 > span {
    display: inline-block;
    margin-left: 10px;
    height: 24px;
    padding: 0 15px;
    border-radius: 3px;
    color: #FFFFFF;
    font-size: 12px;
    line-height: 24px;
  }

  .weather > div > div:nth-child(1) > div:nth-child(2) > p {
    height: 20px;
    margin-bottom: 5px;
    color: #FFFFFF;
  }

  .weather > div > div:nth-child(1) > div:nth-child(3) {
    position: absolute;
    right: 10px;
    top: 20px;
  }

  .weather > div > div:nth-child(1) > div:nth-child(3) > p:nth-child(1) {
    font-size: 40px;
    color: #00f0ff;
    line-height: 40px;
    margin-bottom: 5px;
    height: 40px;
  }

  .weather > div > div:nth-child(1) > div:nth-child(3) > p:nth-child(2) {
    font-size: 16px;
    color: #00f0ff;
    text-align: right;
  }

  .weather > div > ul {
    width: 100%;
    height: auto;
  }

  .weather > div > ul > li {
    width: 16.6%;
    height: auto;
    float: left;
  }

  .weather > div > ul > li > p:nth-child(1) {
    font-size: 12px;
    color: #FFFFFF;
    margin-bottom: 5px;
    text-align: center;
  }

  .weather > div > ul > li > p:nth-child(2) {
    font-size: 12px;
    color: #95bee5;
    margin-bottom: 5px;
    text-align: center;
  }

  .weather > div > ul > li > img {
    display: block;
    margin: 0 auto;
    max-width: 60%;
  }

  .weather > div > ul > li > p:nth-child(4) {
    color: #95bee5;
    font-size: 12px;
    text-align: center;
  }

  .pollutant {
    width: 100%;
    padding: 20px;
    height: 100%;
    box-sizing: border-box;
  }

  .pollutant > h1 {
    font-size: 20px;
    color: #00f0ff;
    height: 20px;
    line-height: 20px;
    margin-bottom: 10px;
  }

  .pollutant > p {
    height: 20px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
  }

  .pollutant > p > span {
    display: block;
    width: 50%;
    height: 20px;
    color: #95bee5;
    box-sizing: border-box;
  }

  .pollutant > ul {
    width: 100%;
    height: calc(100% - 60px);
    overflow-y: auto;
    padding-top: 10px;
  }

  .pollutant > ul > li {
    width: 100%;
    margin-bottom: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .pollutant > ul > li > span:nth-child(1) {
    width: 60px;
    height: 20px;
    color: #FFFFFF;
    text-align: right;
    padding-right: 10px;
    box-sizing: border-box;
  }

  .pollutant > ul > li > span:nth-child(3) {
    width: 100px;
    height: 20px;
    color: #FFFFFF;
    text-align: left;
    padding-left: 20px;
    box-sizing: border-box;
  }

  .pollutant > ul > li > div {
    width: calc(100% - 160px);
    height: 100%;
    position: relative;
  }

  .pollutant > ul > li > div > div:nth-child(1) {
    width: 20px;
    height: 20px;
    position: absolute;
    border-radius: 50%;
    left: 0;
    top: 0;
  }

  .pollutant > ul > li > div > div:nth-child(2) {
    width: calc(100% - 10px);
    height: 16px;
    margin-top: 2px;
    margin-left: 10px;
    padding: 2px;
    box-sizing: border-box;
    border: 1px solid;
    border-right: 3px solid;
    border-radius: 3px;
  }

  .pollutant > ul > li > div > div:nth-child(2) > span {
    display: block;
    height: 100%;
    position: relative;
    max-width: 100%;
  }

  .pollutant > ul > li > div > div:nth-child(2) > span > span {
    position: absolute;
    left: calc(100% + 5px);
    top: -5px;
    font-size: 12px;
    z-index: 99;
    display: inline-block;
  }

  .monitoringPoint {
    padding: 20px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  }

  .monitoringPoint > h1 {
    font-size: 20px;
    color: #00f0ff;
    height: 20px;
    line-height: 20px;
    margin-bottom: 10px;
  }

  .monitoringPoint > div {
    width: 100%;
    height: calc(100% - 30px);
    border: 1px solid #094b8e;
    border-radius: 8px;
    overflow: hidden;
  }

  .monitoringPoint table {
    width: 100%;
    height: 100%;
    border: 1px solid #094b8e;
    border-radius: 5px;
  }

  .monitoringPoint table thead tr {
    height: 60px;
    border-bottom: 1px solid #094b8e;
  }

  .monitoringPoint table thead tr th {
    color: #FFFFFF;
    font-size: 16px;
  }

  .monitoringPoint table tbody {
    display: block;
    height: 100%;
    overflow-y: scroll;
  }

  .monitoringPoint table thead tr,
  .monitoringPoint table tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
    text-align: center;
  }

  .monitoringPoint table tbody tr {
    background: #16518d;
    border-bottom: 1px solid #094b8e;
  }

  .monitoringPoint table tbody tr:nth-child(2n+0) {
    background: #11406f;
  }

  .monitoringPoint table tbody tr td {
    height: 54px;
    color: #FFFFFF;
  }

  .monitoringPoint table tbody tr td span {
    width: 46px;
    height: 24px;
    border-radius: 3px;
    line-height: 24px;
    text-align: center;
    display: inline-block;
    font-size: 14px;
  }

  .monitoringPoint thead th,
  .monitoringPoint tbody td {
    width: 50px;
  }

  .monitoringPoint table thead {
    width: calc(100% - 1em);
  }

  .details {
    padding: 20px;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
  }

  .details > h1 {
    width: 100%;
    height: 30px;
    line-height: 30px;
    position: relative;
    display: flex;
    align-items: center;
  }

  .details > h1 > span:nth-child(1) {
    font-size: 20px;
    line-height: 30px;
    color: #00f0ff;
  }

  .details > h1 > span:nth-child(2) {
    margin-left: 20px;
    color: #00f0ff;
    font-size: 14px;
    height: 30px;
    line-height: 30px;
  }

  .details > h1 > button {
    color: #00f0ff;
    background: transparent;
    border: none;
    font-size: 24px;
    position: absolute;
    right: 0;
    top: 0;
    font-family: "方正兰亭中黑_GBK";
    outline: none;
  }

  .details > div:nth-child(2) {
    width: 100%;
    height: 124px;
    background: url("/static/img/details_pic1.png") no-repeat center center;
    position: relative;
  }

  .details > div:nth-child(2) > span {
    position: absolute;
    font-size: 40px;
    font-weight: bold;
    display: block;
    left: 130px;
    width: 80px;
    text-align: center;
    top: 32px;
  }

  .details > div:nth-child(2) > div {
    position: absolute;
    display: block;
    left: 250px;
    width: 80px;
    height: 50px;
    top: 38px;
  }

  .details > div:nth-child(2) > div > p {
    text-align: center;
    margin-bottom: 0;
  }

  .details > div:nth-child(2) > div > p:nth-child(1) {
    font-size: 18px;
    color: #95bee5;
  }

  .details > div:nth-child(2) > div > p:nth-child(2) {
    font-size: 16px;
  }

  .details > p:nth-child(3) {
    text-align: center;
    font-size: 14px;
    color: #95bee5;
    margin-bottom: 10px;
  }

  .details > div:nth-child(4) {
    position: relative;
    background: url("/static/img/details_pic2.png") no-repeat top center;
    height: 90px;
    width: 100%;
    border-bottom: 1px dashed #264a7c;
    margin-bottom: 10px;
    position: relative;
  }

  .details > div:nth-child(4) > div {
    position: absolute;
    left: 18px;
    top: 29px;
    width: 423px;
    height: 15px;
  }

  .details > div:nth-child(4) > div > span {
    width: 30px;
    height: 30px;
    margin-left: -15px;
    background: url("/static/img/details_pic3.png") no-repeat center center;
    position: absolute;
    left: 395px;
    top: -7px;
  }

  .details > h3 {
    font-size: 14px;
    color: #95bee5;
    height: 26px;
    line-height: 26px;
    margin-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/03Monitoring/2_environment/statistics.vue